import React from "react";
import { List, Datagrid, TextField, DeleteButton } from "react-admin";
import ParticipantsField from "./ParticipantsField";

const ChatList = (props) => (
  <List {...props}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <ParticipantsField source="participants" />
      <TextField source="numberOfMessages" />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default ChatList;
